// extracted by mini-css-extract-plugin
export default {"select":"styles_select__1nxHf","upload_result":"styles_upload_result__lxXbI"};